/**
 * Formats a numeric value for display with at most one digit to the right of the
 * decimal point, stripping trailing zeros and floating-point noise.
 * e.g. 408.53999999999996 -> "408.5", 332.4 -> "332.4", 400 -> "400".
 */
export function formatMaxOneDecimal(value: number | undefined | null): string {
    return parseFloat((value ?? 0).toFixed(1)).toString();
}

export function calcTotalUsablePoints(
    availableBalance: number | undefined | null,
    pointsAvailable: number | undefined | null,
): number {
    return Math.max(0, (availableBalance ?? 0) + Math.max(0, pointsAvailable ?? 0));
}

export function hasTotalUsablePoints(
    availableBalance: number | undefined | null,
    pointsAvailable: number | undefined | null,
): boolean {
    return calcTotalUsablePoints(availableBalance, pointsAvailable) > 0;
}
